import ClipboardJS from 'clipboard'

function clearSelection() {
  if (window.getSelection) {
    window.getSelection().removeAllRanges()
  } else if (document.selection) {
    document.selection.empty()
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-undef
  const clipboard = new ClipboardJS('.clipboard-btn')

  clipboard.on('success', () => {
    clearSelection()
  })

  clipboard.on('error', () => {
    clearSelection()
  })
})
